import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f044d2e")

_pushScopeId("data-v-4f044d2e")
const _hoisted_1 = { class: "auth-nav" }
const _hoisted_2 = {
  key: 0,
  class: "auth-nav__list"
}
const _hoisted_3 = { class: "auth-nav__item" }
const _hoisted_4 = { class: "auth-nav__item" }
const _hoisted_5 = {
  key: 1,
  class: "auth-nav__list"
}
const _hoisted_6 = { class: "auth-nav__item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("nav", _hoisted_1, [
      (!_ctx.isSigned)
        ? (_openBlock(), _createBlock("ul", _hoisted_2, [
            _createVNode("li", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.RouterName.SIGNUP },
                title: _ctx.t('sign up')
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("sign up")), 1)
                ]),
                _: 1
              }, 8, ["to", "title"])
            ]),
            _createVNode("li", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.RouterName.SIGNIN },
                class: "-button",
                title: _ctx.t('sign in')
              }, {
                default: _withId(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.t("sign in")), 1)
                ]),
                _: 1
              }, 8, ["to", "title"])
            ])
          ]))
        : (_openBlock(), _createBlock("ul", _hoisted_5, [
            _createVNode("li", {
              class: _ctx.isActive('/mypage') ? 'auth-nav__item -active' : 'auth-nav__item'
            }, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.RouterName.PROFILE },
                title: _ctx.t('my page')
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("my page")), 1)
                ]),
                _: 1
              }, 8, ["to", "title"])
            ], 2),
            _createVNode("li", _hoisted_6, [
              _createVNode("a", {
                class: "-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                title: _ctx.t('sign out')
              }, [
                _createVNode("span", null, _toDisplayString(_ctx.t("sign out")), 1)
              ], 8, ["title"])
            ])
          ]))
    ])
  ]))
})